<template>
  <v-container fluid class="ma-0 pa-0">
    <EditInventoryListTargeting :list="list" :loading="loading" class="wrap" />
  </v-container>
</template>
<script>
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdvertiser } from '@/mixins/setDrawerTypeAdvertiser'
import { setToolbarTypeAdvertiser } from '@/mixins/setToolBarTypeAdvertiser'
import EditInventoryListTargeting from '@/components/Admin/InventoryListTargeting/InventoryListTargeting'

export default {
  name: 'InventoryTargetingAdvertiser',
  components: { EditInventoryListTargeting },
  mixins: [
    accountInitializer,
    setDrawerTypeAdvertiser,
    setToolbarTypeAdvertiser,
  ],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    list() {
      return this.$store.getters['inventoryTargeting/list']
    },
  },
  async created() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      await this.$store.dispatch(
        'inventoryListTargeting/GET_LIST_FOR_ADVERTISER',
        {
          advertiserId: this.$route.params.advertiserId,
        },
      )
      this.loading = false
    },
  },
}
</script>

<style scoped></style>
